import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["action", "flowObjectTypeId", "getHeaderTitle", "getActionOutputsForTargetActionById"];
import PropTypes from 'prop-types';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import Action from 'automation-ui-action-features/records/Action';
import StaticBranchActionSummary from 'automation-ui-action-features/actions/static-branch/StaticBranchActionSummary';
import { jsx as _jsx } from "react/jsx-runtime";
function StaticBranchActionCard(_ref) {
  let {
      action,
      flowObjectTypeId,
      getHeaderTitle,
      getActionOutputsForTargetActionById
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const actionId = action.getActionId();
  const actionMetadata = action.getMetadata();
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({
    content: /*#__PURE__*/_jsx(StaticBranchActionSummary, {
      actionId: actionId,
      actionMetadata: actionMetadata,
      flowObjectTypeId: flowObjectTypeId,
      getHeaderTitle: getHeaderTitle,
      getActionOutputsForTargetActionById: getActionOutputsForTargetActionById
    }),
    headerTitle: getHeaderTitle({
      actionId
    })
  }, rest));
}
StaticBranchActionCard.propTypes = {
  action: PropTypes.instanceOf(Action).isRequired,
  flowObjectTypeId: PropTypes.string.isRequired,
  getHeaderTitle: PropTypes.func.isRequired,
  getActionOutputsForTargetActionById: PropTypes.func.isRequired
};
export default StaticBranchActionCard;